module.exports = {
	"portalCode": "GATEWAY",
	"capabilities": {
		"config": "base-with-billing",
		"app": {
			"base": [
				"addresslookup",
				"gateway",
				"quoteandbind",
				"policycommon",
				"endorsement",
				"policyjob",
				"policy",
				"platform",
				"api",
				"faq",
				"gw-portals-bop-components-angular",
				"gw-portals-cp-components-angular",
				"gw-portals-policytransaction-angular",
				"gw-portals-policytransaction-common-angular",
				"gw-portals-policytransaction-pc-bop-angular",
				"gw-portals-policytransaction-pc-bop-js",
				"gw-portals-policytransaction-pc-cp-angular",
				"gw-portals-policytransaction-pc-cp-js",
				"gw-portals-policytransaction-renewal-bop-angular",
				"gw-portals-policytransaction-renewal-cp-angular",
				"gw-portals-renewal-angular",
				"gw-portals-renewal-js"
			],
			"base-with-billing": [
				"addresslookup",
				"gateway",
				"quoteandbind",
				"policycommon",
				"endorsement",
				"policyjob",
				"policy",
				"billing",
				"platform",
				"api",
				"faq",
				"gw-portals-bop-components-angular",
				"gw-portals-cp-components-angular",
				"gw-portals-policytransaction-angular",
				"gw-portals-policytransaction-common-angular",
				"gw-portals-policytransaction-pc-bop-angular",
				"gw-portals-policytransaction-pc-bop-js",
				"gw-portals-policytransaction-pc-cp-angular",
				"gw-portals-policytransaction-pc-cp-js",
				"gw-portals-policytransaction-renewal-bop-angular",
				"gw-portals-policytransaction-renewal-cp-angular",
				"gw-portals-renewal-angular",
				"gw-portals-renewal-js"
			],
			"base-with-claims": [
				"addresslookup",
				"gateway",
				"claim",
				"fnol",
				"quoteandbind",
				"policycommon",
				"endorsement",
				"policy",
				"policyjob",
				"platform",
				"api",
				"faq",
				"gw-portals-bop-components-angular",
				"gw-portals-cp-components-angular",
				"gw-portals-policytransaction-angular",
				"gw-portals-policytransaction-common-angular",
				"gw-portals-policytransaction-pc-bop-angular",
				"gw-portals-policytransaction-pc-bop-js",
				"gw-portals-policytransaction-pc-cp-angular",
				"gw-portals-policytransaction-pc-cp-js",
				"gw-portals-policytransaction-renewal-bop-angular",
				"gw-portals-policytransaction-renewal-cp-angular",
				"gw-portals-renewal-angular",
				"gw-portals-renewal-js"
			],
			"base-with-billing-and-claims": [
				"addresslookup",
				"gateway",
				"claim",
				"fnol",
				"quoteandbind",
				"policycommon",
				"endorsement",
				"policy",
				"policyjob",
				"billing",
				"platform",
				"api",
				"faq",
				"gw-portals-bop-components-angular",
				"gw-portals-cp-components-angular",
				"gw-portals-policytransaction-angular",
				"gw-portals-policytransaction-common-angular",
				"gw-portals-policytransaction-pc-bop-angular",
				"gw-portals-policytransaction-pc-bop-js",
				"gw-portals-policytransaction-pc-cp-angular",
				"gw-portals-policytransaction-pc-cp-js",
				"gw-portals-policytransaction-renewal-bop-angular",
				"gw-portals-policytransaction-renewal-cp-angular",
				"gw-portals-renewal-angular",
				"gw-portals-renewal-js"
			],
			"base-with-billing-claims-and-journey": [
				"addresslookup",
				"gateway",
				"claim",
				"fnol",
				"quoteandbind",
				"policycommon",
				"endorsement",
				"policy",
				"policyjob",
				"billing",
				"platform",
				"api",
				"faq",
				"journey",
				"gw-portals-bop-components-angular",
				"gw-portals-cp-components-angular",
				"gw-portals-policytransaction-angular",
				"gw-portals-policytransaction-common-angular",
				"gw-portals-policytransaction-pc-bop-angular",
				"gw-portals-policytransaction-pc-bop-js",
				"gw-portals-policytransaction-pc-cp-angular",
				"gw-portals-policytransaction-pc-cp-js",
				"gw-portals-policytransaction-renewal-bop-angular",
				"gw-portals-policytransaction-renewal-cp-angular",
				"gw-portals-renewal-angular",
				"gw-portals-renewal-js"
			]
		},
		"test": []
	},
	"localization": {
		"generateDtoKeys": {
			"service": {
				"pc": "gatewaylocale/locale"
			}
		}
	},
	"versions": [
		{
			"features": {
				"versionName": "agents",
				"oAuthRedirectHomePage": "index-agents.html"
			},
			"releaseName": "ProducerEngage"
		},
		{
			"features": {
				"versionName": "csrs",
				"oAuthRedirectHomePage": "index-csrs.html"
			},
			"releaseName": "ServiceRepEngage"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./common/~/json-loader!./build.config.json
// module id = 1275
// module chunks = 0